import { useSignedPreviewUrl } from 'Data/s3'
import React from 'react'
import { useDataValue } from 'Simple/Data'

import View from './view.js'

export default function Logic(props) {
  let url = useDataValue({
    context: 'person',
    path: 'profile_pic_url',
    viewPath: props.viewPath,
  })
  let presignedUrl = useSignedPreviewUrl({
    url,
    viewPath: props.viewPath,
  })

  return <View {...props} presignedUrl={presignedUrl} />
}
